import { render, staticRenderFns } from "./getlott.vue?vue&type=template&id=223493fc&scoped=true&"
import script from "./getlott.vue?vue&type=script&lang=js&"
export * from "./getlott.vue?vue&type=script&lang=js&"
import style0 from "./getlott.vue?vue&type=style&index=0&id=223493fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223493fc",
  null
  
)

export default component.exports